import { MutationTree } from "vuex";
import { RootState } from "./types";
import { ThemeConfig } from "@/plugins/config";

type RootMutationsTree = MutationTree<RootState>;

export const mutations: RootMutationsTree = {
  setOnline(state: RootState, payload: boolean) {
    state.isOnline = payload;
  },

  setCurrentTheme(state: RootState, theme: ThemeConfig) {
    state.theme = theme;
  },
};
